interface Props {
  label: string;
  value: string;
  hint?: string;
  tone?: 'neutral' | 'positive' | 'negative' | 'warning';
}

const toneClass: Record<NonNullable<Props['tone']>, string> = {
  neutral: 'text-slate-100',
  positive: 'text-emerald-300',
  negative: 'text-red-300',
  warning: 'text-amber-300',
};

export function SummaryCard({ label, value, hint, tone = 'neutral' }: Props): JSX.Element {
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-lg px-4 py-3">
      <div className="text-xs text-slate-500 uppercase tracking-wider">{label}</div>
      <div className={`text-xl font-semibold mt-1 ${toneClass[tone]}`}>{value}</div>
      {hint !== undefined && hint !== '' && (
        <div className="text-xs text-slate-500 mt-1">{hint}</div>
      )}
    </div>
  );
}
